import { render, staticRenderFns } from "./GeoFenceRecord-componet.vue?vue&type=template&id=ed0dc24a&scoped=true"
import script from "./GeoFenceRecord-componet.vue?vue&type=script&lang=js"
export * from "./GeoFenceRecord-componet.vue?vue&type=script&lang=js"
import style0 from "./GeoFenceRecord-componet.vue?vue&type=style&index=0&id=ed0dc24a&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0dc24a",
  null
  
)

export default component.exports